import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { MissionIdParams } from '@src/core/entities';
import { ARC_MAP_EVENT, ArcMapEvent, ArcPolyline, DistanceLabel, getLocationFromMap } from '@src/core/controllers';
import { DestinationPoint, TakeOffPoint } from '@src/features/order/pages/upsert-order-page/components';
import { selectPath, setDestinationLocation } from '@src/features/order/pages/upsert-order-page/redux';
import { selectEditableRoute, selectWaypoints } from '@src/features/order/pages/upsert-mission-page/redux';
import CreateRouteMap from '@src/features/order/pages/upsert-mission-page/maps/create-route';

// Combined map for the single-page Flight Plan. Before a route is planned the user places
// the takeoff + destination points; once the order is persisted the background route plan
const FlightPlanMap: React.FC = () => {
  const dispatch = useDispatch();
  const path = useSelector(selectPath);
  const waypoints = useSelector(selectWaypoints);
  const editableRoute = useSelector(selectEditableRoute);
  const { missionId } = useParams<MissionIdParams>();
  const isEditMission = Boolean(missionId);

  const hasRoute = waypoints.length > 0;

  const onDblClick = async (e: google.maps.MapMouseEvent) => {

    if (editableRoute) return;

    const lat = e.latLng?.lat();
    const lng = e.latLng?.lng();
    if (lat == null || lng == null) return;

    // Mark the destination coordinates immediately so the old route clears and the loader
    // appears right away — without waiting for reverse geocoding to resolve the address.
    dispatch(setDestinationLocation({ latitude: lat, longitude: lng, address: '' }));

    const location = await getLocationFromMap(e);
    if (location) dispatch(setDestinationLocation(location));
  };

  return (
    <React.Fragment>
      <TakeOffPoint seedFromHub={false} />
      <DestinationPoint />

      {!hasRoute && !isEditMission ? (
        <React.Fragment>
          <ArcPolyline.future path={path} />
          <DistanceLabel path={path} />
        </React.Fragment>
      ) : null}

      <ArcMapEvent handler={onDblClick} eventName={ARC_MAP_EVENT.onDblClick} />

      <CreateRouteMap hideRouteDestination />
    </React.Fragment>
  );
};

export { FlightPlanMap };
export default FlightPlanMap;
